import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setConfig, setSiteInfo } from "@/redux/slices/config/configSlice";
import { configSelector } from "@/redux/slices/config/selectors";
import { SiteConfig } from "@/redux/slices/config/types";
import { transformRMConfig } from "../helpers";

type UseRMConfig =
  | {
      isReady: false;
      config?: undefined;
    }
  | {
      isReady: true;
      config: SiteConfig;
    };

const RMConfig = window.rm ? window.rm.config : undefined;

export const useRMConfig = (): UseRMConfig => {
  const dispatch = useAppDispatch();
  const config = useAppSelector(configSelector);

  useEffect(() => {
    if (RMConfig) {
      // Set siteInfo from RMConfig
      dispatch(
        setSiteInfo({
          key: RMConfig.site.domain_key,
          isMultiTenant: RMConfig.site.metadata.is_multi_tenant,
          apiUrl: RMConfig.site.url.api,
          url: RMConfig.site.url.domain,
        })
      );
      dispatch(setConfig(transformRMConfig(RMConfig)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!config) return { isReady: false, config: undefined };
  return { isReady: true, config } satisfies UseRMConfig;
};
